module.exports = __webpack_public_path__ + "static/media/Ma_CkipTagger_1129.2f82ba88.pdf";